import { routeProductsTestShackManager } from "@/setup/routes/products.routes";
import { TestShackManagerShiftRedirect } from "./components/TestShackManagerShiftRedirect";
import { TestShackManagerPage } from "./TestShackManagerPage";

export const ProductsTestShackManager = () => {
	return <TestShackManagerPage />;
};

export const ProductsTestShackManagerShift = () => (
	<TestShackManagerShiftRedirect managerRoute={routeProductsTestShackManager} />
);
